import { render, staticRenderFns } from "./RealTimeQRRegistration.vue?vue&type=template&id=49ae2816"
import script from "./RealTimeQRRegistration.vue?vue&type=script&lang=js"
export * from "./RealTimeQRRegistration.vue?vue&type=script&lang=js"
import style0 from "./RealTimeQRRegistration.vue?vue&type=style&index=0&id=49ae2816&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports